import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=03bdd662&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectOverview.vue?vue&type=script&lang=ts"
import style0 from "./ProjectOverview.vue?vue&type=style&index=0&id=03bdd662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdd662",
  null
  
)

export default component.exports